import { AbstractModel } from '@uzurv/core';
import { MVROrder } from './mvr-order';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { MVRReport } from './mvr-report';

@inheritSerialization(AbstractModel)
export class MvrDetails extends AbstractModel {
  @autoserializeAs(MVROrder)
  mvrOrder: MVROrder;

  @autoserializeAs(MVRReport)
  mvrReport: MVRReport;

  @autoserialize
  mvrPortalUrl: string;
}
